import { ArrowDropDown, Refresh, Search } from '@material-ui/icons';
import { Button, Input, Select } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'react-recompose';

const { Option } = Select;

const AuditLogsFilter = ({ intl, onActionStateFilter, searchText, onSearch, onKeyDownSearch, onApplyFilter }) => {
  const actionStates = [
    { value: 'all', label: intl.formatMessage({ id: 'All' }) },
    { value: 'activate', label: intl.formatMessage({ id: 'activate' }) },
    { value: 'deactivate', label: intl.formatMessage({ id: 'deactivate' }) },
    { value: 'update', label: intl.formatMessage({ id: 'update' }) },
    { value: 'delete', label: intl.formatMessage({ id: 'delete' }) },
    { value: 'create', label: intl.formatMessage({ id: 'create' }) },
  ];

  const handleActionStateFilter = values => {
    onActionStateFilter(values);
  };

  const handleSearch = e => {
    onSearch(e);
  };

  return (
    <div className="auditLogs_filter_layout">
      <Select
        className="action_states"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Action' })}
        onChange={handleActionStateFilter}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
        getPopupContainer={trigger => trigger.parentNode}
      >
        {actionStates.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter}>
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder={intl.formatMessage({ id: 'Search' })}
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => onKeyDownSearch(e)}
      />
    </div>
  );
};

export default compose(injectIntl)(AuditLogsFilter);
